import { Effect, Schema as S } from "effect";
import * as Command from "foldkit/command";
import { defineMessageUnion } from "foldkit/message";

export const DownloadMessage = defineMessageUnion({ CompletedDownload: {} });

const saveText = (fileName: string, text: string, type: string) =>
	Effect.sync(() => {
		const url = URL.createObjectURL(new Blob([text], { type }));
		const link = document.createElement("a");
		link.href = url;
		link.download = fileName;
		link.click();
		window.setTimeout(() => URL.revokeObjectURL(url), 1_000);
	}).pipe(Effect.as(DownloadMessage.CompletedDownload()));

/** v1's anchor-click download of a pretty-printed JSON payload (KTD6: no `foldkit/file`). */
export const DownloadJson = Command.define("DownloadJson", {
	args: { fileName: S.String, json: S.String },
	messages: [DownloadMessage.CompletedDownload],
	execute: ({ fileName, json }) => saveText(fileName, json, "application/json"),
});

export const DownloadMarkdown = Command.define("DownloadMarkdown", {
	args: { fileName: S.String, markdown: S.String },
	messages: [DownloadMessage.CompletedDownload],
	execute: ({ fileName, markdown }) =>
		saveText(fileName, markdown, "text/markdown"),
});

export const prettyJson = (payload: unknown): string =>
	JSON.stringify(payload, null, 2);
